const content = {
  content_about_us_developer: 'SignalStickerMaker.com（Web）、Sigicker（iOS）、SignalSticker Maker（Android）の開発者：',
  content_about_us_ads: 'このアプリケーションは開発者によって完全に資金提供されており、サーバーホスティング、ネットワーキング、アプリ開発などのコストが含まれます。広告は私たちがコストをカバーしようとする唯一の方法です。広告による影響を最小限に抑えています。ご理解いただきありがとうございます！',
  faq_question_1: 'アップロードした写真はデータベースに保存されますか？',
  faq_answer_1: 'いいえ！すべての画像はステッカーパックが生成された後に削除されます！',
  faq_question_2: '既存のステッカーパックを変更できますか？',
  faq_answer_2: 'Signalの制限により、ステッカーパック全体を再作成することによってのみ変更できます。',
  faq_question_3: 'ステッカーパックの絵文字とカバー画像を指定するにはどうすればよいですか？',
  faq_answer_3: '現在開発中です！お楽しみに！',
};

const text = {
  text_about_us: '私たちについて',
  text_developers: '開発者',
  text_advertisement: '広告',
  text_image_selected: '選択された画像',
  text_image_selected_error: '最低1枚、最大30枚の画像を選択してください',
  text_maximum: '最大',
  text_supported_format: 'サポートされている形式',
  text_field_title: 'タイトル',
  text_field_author: '作者',
  text_make_your_own_sticker: 'オリジナルSignalステッカーを作ろう！',
  text_select_images: '画像を選択',
  text_create_sticker: 'ステッカーを作成',
  text_terms_and_conditions: '利用規約',
  text_terms_and_conditions_2: 'あなたは以下を読み、同意したことを宣言します',
  text_optional: 'オプション',
  text_download_now: '今すぐダウンロード！',
  text_compability: '互換性',
  text_compability_android: 'Android 4.4以上のAndroidデバイス',
  text_developed_by: '開発に使用：',
  text_ssm_on_android: 'Android版SignalStickerMaker',
  text_android_trade_mark: '「Android」、「Android Studio」、「Google PlayStore」およびそれらのロゴはGoogle LLCの商標です。',
  text_ssm_on_ios: 'iOS版SignalStickerMaker',
  text_compability_ios_1: 'iOS 13以上のiPhone、iPad、iPod Touch',
  text_compability_ios_2: 'macOS 11.0以上およびApple M1チップ搭載のMac',
  text_ssm_trade_mark: 'Apple®、Mac®、Mac OS®、iPhone®、iPad®、iPod touch®、App Store®、Swift®、Xcode®、およびそれらのロゴは、米国およびその他の国におけるApple Inc.の登録商標です。',
  text_faq: 'よくある質問',
  text_stats: '統計',
  text_statistics: '統計',
  text_total_sticker_packs: '作成されたステッカーパックの総数',
  text_terms_privacy_condition: '利用規約、プライバシー、条件',
  text_copy_right: '著作権',
  text_give_app_a_try_question: 'アプリ版を試してみませんか？',
  text_better_experience: 'より良い体験',
  text_store_your_sticker: 'ステッカーを保存',
  text_more_convenient: 'より便利',
  text_no_thanks: 'いいえ、結構です！',
  text_creating_sticker: 'ステッカーを作成中',
  text_close: '閉じる',
  text_cancel: 'キャンセル',
  text_copy_to_clipboard: 'クリップボードにコピー',
  text_copied: 'コピーしました！',
  text_add_sticker_now: '今すぐステッカーを追加',
  text_try_again: '再試行',
  text_report_to_us: 'このエラーを報告する',
  text_reported: '報告済み',
  text_image_converting: '画像を変換中...',
  text_sticker_created_successfully: 'ステッカーが正常に作成されました！',
  text_service_busy: 'Signalアップロードサービスが混雑しています。数時間後に再試行してください！',
  text_upload_failed_try_again: 'アップロードに失敗しました。後でもう一度お試しください！',
  text_image_uploading: '画像をアップロード中...',
  text_step_converting_image: '画像を変換中',
  text_step_uploading_image: '画像をアップロード中',
  text_step_result: '結果',
  text_educational_title: '数分でプロフェッショナルなSignalステッカーパックを作成',
  text_educational_description: '無料で使いやすいツールで、画像をカスタムSignalステッカーパックに変換します。友達用の個人的なステッカー、ビジネスブランディング素材、芸術的表現など、何を作成していても、私たちのプラットフォームはプロセスをシンプルで安全にします。技術的なスキルは必要ありません！',
  text_quick_tips_title: '💡 より良いステッカーのためのクイックヒント',
  text_tip_1: '鮮明な結果のために高解像度の画像（最低512x512ピクセル）を使用してください',
  text_tip_2: '透明な背景の画像にはPNG形式が最適です',
  text_tip_3: '縮小されても認識可能でシンプルなデザインを保つ',
  text_tip_4: '最高のバラエティのために1パックにつき10-30個のステッカーを作成',
  text_about_signal_title: 'Signalについて',
  text_about_signal_description: 'Signalはプライバシーに重点を置いたメッセージングアプリで、カスタムステッカーパックをサポートしています。独自のユニークなステッカーを作成・共有して、会話をより個人的で楽しいものにしましょう。',
  text_sticker_guide_card_title: '完全ステッカーガイド',
  text_sticker_guide_card_description: 'プロフェッショナルなSignalステッカーパックを作成するためのベストプラクティス、デザイン原則、ステップバイステップの指示を学びます。',
  text_image_formats_card_title: '画像フォーマットガイド',
  text_image_formats_card_description: 'PNG、WEBP、JPEG、GIF形式の違いを理解して、ステッカーに最適なオプションを選択します。',
  text_learn_more: '詳細を見る',
  // Sticker Guide Section - Japanese
  sticker_guide_image_quality_title: 'ステッカー画像の品質ガイド',
  sticker_guide_image_quality_1: '高解像度画像（最低512x512ピクセル）を使用',
  sticker_guide_image_quality_2: '画像を鮮明に保ち、ぼやけを避ける',
  sticker_guide_image_quality_3: '過度な圧縮や劣化を避ける',
  sticker_guide_design_principles_title: 'デザイン原則',
  sticker_guide_design_principles_1: 'シンプルで認識しやすいデザイン',
  sticker_guide_design_principles_2: '鮮やかな色と明確な輪郭を使う',
  sticker_guide_design_principles_3: '明暗どちらの背景でも見やすいようにする',
  sticker_guide_formats_title: 'ステッカー形式の比較',
  sticker_guide_formats_description: 'SignalステッカーはPNG、WEBP、JPEG、GIFに対応。各形式の特徴：',
  sticker_guide_png_title: 'PNG（透明背景）',
  sticker_guide_png_best_for: '透明背景のステッカーに最適',
  sticker_guide_png_advantages: 'ロスレス圧縮、高品質',
  sticker_guide_png_file_size: 'ファイルサイズは大きめ',
  sticker_guide_webp_title: 'WEBP（高効率圧縮）',
  sticker_guide_webp_best_for: '高品質かつ小さいファイルサイズが必要な場合に最適',
  sticker_guide_webp_advantages: '透明対応、ファイルサイズが小さい',
  sticker_guide_webp_file_size: '最も小さいファイルサイズ',
  sticker_guide_jpeg_title: 'JPEG（写真）',
  sticker_guide_jpeg_best_for: '写真系ステッカーに最適',
  sticker_guide_jpeg_advantages: '小さいファイルサイズ、多色対応',
  sticker_guide_jpeg_limitations: '透明非対応、圧縮で劣化する場合あり',
  sticker_guide_gif_title: 'GIF（アニメーション）',
  sticker_guide_gif_best_for: 'シンプルなアニメステッカーに最適',
  sticker_guide_gif_advantages: 'アニメーション対応',
  sticker_guide_gif_limitations: '色数が少ない、透明非対応',
  sticker_guide_how_to_title: 'Signalステッカーの作り方',
  sticker_guide_how_to_description: '以下の手順で簡単にステッカーを作成できます：',
  sticker_guide_step_1: '使いたい画像を選ぶ',
  sticker_guide_step_2: '画像が品質基準を満たしているか確認',
  sticker_guide_step_3: '適切な形式（PNG/WEBP/JPEG/GIF）を選択',
  sticker_guide_step_4: 'Signalステッカーメーカーで画像をアップロード',
  sticker_guide_step_5: 'ステッカーをプレビュー・調整',
  sticker_guide_step_6: '完成したらダウンロードまたは共有',
  sticker_guide_advanced_tips_title: '上級テクニック',
  sticker_guide_advanced_tips_description: 'より人気のステッカーにするためのコツ：',
  sticker_guide_consistency_title: '統一感',
  sticker_guide_consistency_description: 'パック全体で統一されたスタイルやテーマを持たせる',
  sticker_guide_emotional_range_title: '感情のバリエーション',
  sticker_guide_emotional_range_description: '様々な感情や反応のステッカーを作成し、会話を豊かにする',
  sticker_guide_test_others_title: '友達に試してもらう',
  sticker_guide_test_others_description: '友達に使ってもらい、フィードバックをもらって改善する',
  
  // Sticker Guide Page
  sticker_guide_page_title: 'Signalステッカー作成完全ガイド',
  sticker_guide_page_description: '包括的なガイドでプロフェッショナルなSignalステッカーパックの作成方法を学びます。ベストプラクティス、ファイル形式、デザインのヒント、ステップバイステップの指示を発見してください。',
  sticker_guide_what_are_title: 'Signalステッカーとは？',
  sticker_guide_what_are_description: 'Signalステッカーは、Signal会話で感情、反応、アイデアを表現するために使用できるカスタム絵文字と画像です。通常の絵文字とは異なり、Signalステッカーは完全にカスタマイズして個人化でき、ユニークな視覚的コミュニケーション体験を作成できます。',
  sticker_guide_why_use_title: 'なぜカスタムステッカーを使用するのか？',
  sticker_guide_why_use_description: 'カスタムステッカーは標準的な絵文字よりもいくつかの利点があります：',
  sticker_guide_advantage_1: '個人的表現：あなたの個性、ユーモア、内輪ネタを反映するステッカーを作成',
  sticker_guide_advantage_2: 'ブランドアイデンティティ：企業は顧客エンゲージメントのためのブランドステッカーを作成可能',
  sticker_guide_advantage_3: '文化的関連性：あなたの文化的背景やコミュニティに共鳴するステッカーを作成',
  sticker_guide_advantage_4: '記憶に残るコミュニケーション：ユニークな視覚要素で会話の中で目立つ',
  sticker_guide_best_practices_title: 'ステッカー作成のベストプラクティス',
  sticker_guide_best_practices_description: '効果的で魅力的なステッカーを作成するには、これらのガイドラインに従ってください：',
  sticker_guide_ready_title: '自分のステッカーを作成する準備はできましたか？',
  sticker_guide_ready_description: 'ステッカー作成の基本を理解したので、アイデアを実現する準備が整いました！無料のSignalステッカーメーカーを使用して、画像を友達、家族、またはSignalコミュニティ全体と共有できるプロフェッショナルなステッカーパックに変換してください。',
  
  // Image Formats Page
  image_formats_page_title: '画像フォーマットの理解：完全ガイド',
  image_formats_page_description: '今日のデジタル世界では、適切な画像フォーマットを選択することで、ウェブサイトのパフォーマンス、ユーザーエクスペリエンス、視覚的品質に大きく影響を与えることができます。ステッカーの作成、ウェブサイトの構築、写真の共有など、画像フォーマット間の違いを理解することは、情報に基づいた決定を下すために重要です。',
  image_formats_what_are_title: '画像フォーマットとは？',
  image_formats_what_are_description: '画像フォーマットは、デジタル画像データを整理・保存する標準化された方法です。各フォーマットは、ファイルサイズ、品質、機能性のバランスを取るために、異なる圧縮アルゴリズム、色表現、機能セットを使用します。フォーマットの選択は、ウェブパフォーマンス、印刷品質、透明度サポート、またはアニメーション機能など、特定のニーズに依存します。',
  image_formats_comparison_title: '詳細フォーマット比較',
  image_formats_future_title: '画像フォーマットの未来',
  image_formats_future_description: '画像フォーマットの世界は新しい技術とともに進化し続けています：',
  
  // PNG Section
  image_formats_png_title: 'PNG（Portable Network Graphics）',
  image_formats_png_description: 'PNGは透明性を必要とするWebグラフィックスの標準となった可逆圧縮フォーマットです。',
  image_formats_png_features_title: '主な特徴：',
  image_formats_png_feature_1: '可逆圧縮 - 品質劣化なし',
  image_formats_png_feature_2: '完全なアルファチャンネル透明度サポート',
  image_formats_png_feature_3: '最大1670万色をサポート',
  image_formats_png_feature_4: '鋭いエッジとテキストを持つグラフィックスに最適',
  image_formats_png_uses_title: '最適な使用例：',
  image_formats_png_use_1: 'ウェブサイトのロゴとアイコン',
  image_formats_png_use_2: 'スクリーンショットとユーザーインターフェース要素',
  image_formats_png_use_3: '透明な背景を必要とする画像',
  image_formats_png_use_4: 'テキストオーバーレイを持つグラフィックス',
  image_formats_png_limitations_title: '制限事項：',
  image_formats_png_limitations: '非可逆フォーマットと比較してファイルサイズが大きく、ファイルサイズが懸念される大きな写真画像には適していません。',

  // WEBP Section
  image_formats_webp_title: 'WEBP（Web Picture Format）',
  image_formats_webp_description: 'Googleによって開発されたWEBPは、高品質を維持しながら優れた圧縮を提供する現代的な画像フォーマットです。',
  image_formats_webp_features_title: '主な特徴：',
  image_formats_webp_feature_1: 'PNGより25-35%小さいファイルサイズ',
  image_formats_webp_feature_2: '可逆と非可逆の両方の圧縮をサポート',
  image_formats_webp_feature_3: 'アルファチャンネル透明度サポート',
  image_formats_webp_feature_4: 'アニメーションサポート（GIFより優秀）',
  image_formats_webp_uses_title: '最適な使用例：',
  image_formats_webp_use_1: '現代的なWebアプリケーション',
  image_formats_webp_use_2: 'モバイルアプリアセット',
  image_formats_webp_use_3: 'Eコマース製品画像',
  image_formats_webp_use_4: 'ファイルサイズが重要な任意のシナリオ',
  image_formats_webp_limitations_title: '制限事項：',
  image_formats_webp_limitations: '古いブラウザでのサポートが限定的（ただし、この問題は減少しています）。一部の画像編集ソフトウェアはWEBP編集を完全にサポートしていない場合があります。',

  // JPEG Section
  image_formats_jpeg_title: 'JPEG（Joint Photographic Experts Group）',
  image_formats_jpeg_description: 'JPEGは写真画像で最も広く使用されているフォーマットで、複雑な画像に対して優れた圧縮を提供します。',
  image_formats_jpeg_features_title: '主な特徴：',
  image_formats_jpeg_feature_1: '写真の優れた圧縮',
  image_formats_jpeg_feature_2: 'Web使用に理想的な小さなファイルサイズ',
  image_formats_jpeg_feature_3: 'ブラウザとデバイスの汎用サポート',
  image_formats_jpeg_feature_4: '調整可能な品質設定',
  image_formats_jpeg_uses_title: '最適な使用例：',
  image_formats_jpeg_use_1: 'デジタル写真',
  image_formats_jpeg_use_2: 'ソーシャルメディア画像共有',
  image_formats_jpeg_use_3: 'ウェブサイトのヒーロー画像とギャラリー',
  image_formats_jpeg_use_4: 'メール添付ファイル',
  image_formats_jpeg_limitations_title: '制限事項：',
  image_formats_jpeg_limitations: '非可逆圧縮は反復編集により品質を劣化させる可能性があります。透明度サポートなし。鋭いエッジやテキストを含むグラフィックスでのパフォーマンスが悪い。',

  // GIF Section
  image_formats_gif_title: 'GIF（Graphics Interchange Format）',
  image_formats_gif_description: '最も古いWebフォーマットの一つであるにも関わらず、GIFは簡単なアニメーションとグラフィックスで人気を保っています。',
  image_formats_gif_features_title: '主な特徴：',
  image_formats_gif_feature_1: 'アニメーションサポート',
  image_formats_gif_feature_2: '単色透明度',
  image_formats_gif_feature_3: '簡単なグラフィックスの可逆圧縮',
  image_formats_gif_feature_4: 'すべてのプラットフォームでの汎用サポート',
  image_formats_gif_uses_title: '最適な使用例：',
  image_formats_gif_use_1: '簡単なアニメーションとミーム',
  image_formats_gif_use_2: 'ローディングインジケーターとUIアニメーション',
  image_formats_gif_use_3: '色数の少ない簡単なグラフィックス',
  image_formats_gif_use_4: 'ピクセルアートとレトロスタイルグラフィックス',
  image_formats_gif_limitations_title: '制限事項：',
  image_formats_gif_limitations: '256色に制限されており、高品質な写真には適していません。複雑なアニメーションでは大きなファイルサイズ。アルファ透明度サポートなし。',

  // Decision Matrix Section
  image_formats_decision_matrix_title: '正しいフォーマットの選択：決定マトリックス',
  image_formats_decision_guide: '迅速な決定ガイド：',
  image_formats_transparency_title: '透明度用',
  image_formats_transparency_best: '最適：PNG、WEBP',
  image_formats_transparency_avoid: '避ける：JPEG',
  image_formats_photography_title: '写真用',
  image_formats_photography_best: '最適：JPEG、WEBP',
  image_formats_photography_avoid: '避ける：GIF',
  image_formats_animation_title: 'アニメーション用',
  image_formats_animation_best: '最適：WEBP、GIF',
  image_formats_animation_avoid: '避ける：JPEG、PNG',
  image_formats_filesize_title: 'ファイルサイズ用',
  image_formats_filesize_best: '最適：WEBP、JPEG',
  image_formats_filesize_largest: '最大：PNG',

  // Technical Specifications
  image_formats_tech_specs_title: '技術仕様比較',
  image_formats_tech_feature: '機能',
  image_formats_tech_compression: '圧縮タイプ',
  image_formats_tech_transparency: '透明度',
  image_formats_tech_animation: 'アニメーション',
  image_formats_tech_colors: '最大色数',
  image_formats_tech_browser: 'ブラウザサポート',
  image_formats_tech_lossless: '可逆',
  image_formats_tech_both: '両方',
  image_formats_tech_lossy: '非可逆',
  image_formats_tech_alpha: 'アルファチャンネル',
  image_formats_tech_no: 'いいえ',
  image_formats_tech_binary: 'バイナリ',
  image_formats_tech_yes: 'はい',
  image_formats_tech_colors_full: '1670万',
  image_formats_tech_colors_limited: '256',
  image_formats_tech_universal: '汎用',
  image_formats_tech_modern: '現代',

  // Performance Section
  image_formats_performance_title: 'ウェブサイトパフォーマンスへの影響',
  image_formats_performance_description: '画像フォーマットの選択はウェブサイトのパフォーマンスに大きく影響し、ユーザーエクスペリエンスとSEOランキングに直接影響します：',
  image_formats_loading_title: '読み込み速度',
  image_formats_loading_description: '小さなファイルサイズ（WEBP、最適化されたJPEG）はページ読み込み時間の短縮につながり、ユーザー保持とSEOにとって重要です。ページ読み込み時間の1秒の遅延は、コンバージョンを7%減少させる可能性があります。',
  image_formats_mobile_title: 'モバイル体験',
  image_formats_mobile_description: '帯域幅が限られたモバイルデバイスでは、WEBPなどの効率的なフォーマットを選択することで、ユーザーエクスペリエンスを劇的に改善できます。モバイルユーザーは3秒以内にページが読み込まれることを期待しています。',
  image_formats_seo_title: 'SEOメリット',
  image_formats_seo_description: 'Googleはページ速度をランキング要因として考慮しています。最適化された画像はより良いCore Web Vitalsスコアに貢献し、検索エンジンランキングを向上させる可能性があります。',

  // Future Section
  image_formats_future_avif: 'AVIF：WEBPよりもさらに優れた圧縮を提供する新しいフォーマット、ブラウザサポートを徐々に獲得中',
  image_formats_future_heif: 'HEIF：iOSデバイス向けのAppleの推奨フォーマット、優れた圧縮だがWeb サポートは限定的',
  image_formats_future_svg: 'SVG：スケーラブルなグラフィックスとアイコンに最適なベクターフォーマット',

  // Conclusion
  image_formats_conclusion_title: '画像を最適化する準備はできましたか？',
  image_formats_conclusion_description: '各画像フォーマットの長所と短所を理解したので、プロジェクトに対して情報に基づいた決定を下すことができます。Signalステッカーを作成している、ウェブサイトを構築している、またはオンラインでコンテンツを共有している場合でも、適切なフォーマットを選択することで、特定のニーズに対して品質、パフォーマンス、互換性の最適なバランスが確保されます。',
};

const language_spec = {
  lang_code: 'ja',
  name: '日本語',
  flag: '🇯🇵',
};

const menu_items = {
  menu_item_ios: 'iOS',
  menu_item_android: 'Android',
  menu_item_faq: 'FAQ',
  menu_item_about_us: '私たちについて',
  menu_item_support: 'サポート',
  menu_item_create_stickers: 'ステッカーを作成',
  menu_item_sticker_guide: 'ステッカーガイド',
  menu_item_image_formats: '画像フォーマット',
};

const seo = {
  seo_default_title: 'Signal Sticker Maker - オリジナルステッカーを作ろう',
  seo_default_description: '無料のSignalステッカーメーカー - 数分でSignalメッセージングアプリ用のカスタムステッカーを作成。使いやすいオンラインツールでパーソナライズされたステッカーパックを作成。ソフトウェア不要、モバイルとデスクトップで動作します。',
  seo_support_title: 'サポート',
  seo_support_description: 'サポートについてお問い合わせください',
  seo_ios_description: 'SignalStickerMaker.com iOSアプリがApp Storeで利用可能になりました！',
  seo_android_description: 'SignalStickerMaker.com AndroidアプリがGoogle Play Storeで利用可能になりました！',
  seo_about_us_description: 'SignalStickerMaker.comの物語',
  seo_faq_title: 'FAQ',
  seo_faq_description: 'よくある質問を閲覧する',
  seo_title_support: 'サポート',
  seo_title_support_description: 'サポートと支援についてお問い合わせください',
  canvas: 'キャンバス',
  stickerCount: 'ステッカー数',
  about_us_mission_title: '私たちの使命',
  about_us_mission_content: 'Signal Sticker Makerでは、コミュニケーションは個人的で、楽しく、クリエイティブであるべきだと信じています。私たちの使命はステッカー作成を民主化し、誰でもカスタムSignalステッカーで自分を表現できるようにすることです。友達と内輪ネタを共有したり、ビジネスのブランドアイデンティティを構築したり、単に会話に個性を加えたいだけでも、私たちはそれを実現するツールを提供します - 完全に無料で。',
  about_us_why_built_title: 'なぜこれを作ったのか',
  about_us_why_built_content: 'Signal Sticker Makerのアイデアは、カスタムステッカー作成の選択肢が限られていることへの私たちのフラストレーションから生まれました。技術的な専門知識や高価なソフトウェアを必要としない、シンプルでアクセシブルなツールが欲しかったのです。私たちを動かすもの：',
  about_us_accessibility: 'アクセシビリティ：技術スキルに関係なく、誰でもカスタムステッカーを作成できるべき',
  about_us_privacy: 'プライバシー：あなたの画像は安全に処理され、私たちのサーバーに保存されることはありません',
  about_us_simplicity: 'シンプルさ：作成プロセスは数時間ではなく数分で完了するべき',
  about_us_quality: '品質：結果として得られるステッカーは高品質でSignal互換であるべき',
  about_us_team_description: '私たちのチームは、ウェブ開発、ユーザーエクスペリエンスデザイン、モバイルアプリケーションの専門知識を組み合わせ、強力で使いやすいツールを作成しています。私たちはオープンソース技術に情熱を注ぎ、ユーザーのプライバシーを尊重しながら優れた機能を提供する製品を構築することを信じています。',
  about_us_tech_stack_title: '私たちの技術スタック',
  about_us_tech_stack_description: '信頼性、速度、セキュリティを確保するために、現代的なウェブ技術を使用してSignal Sticker Makerを構築しました：',
  about_us_frontend_title: 'フロントエンド',
  about_us_frontend_description: 'レスポンシブで型安全なユーザーインターフェースのためのReact.jsとTypeScript',
  about_us_backend_title: 'バックエンド',
  about_us_backend_description: 'サーバーレス処理のためのAWS Lambdaと安全なファイル処理のためのS3',
  about_us_security_title: 'セキュリティ',
  about_us_security_description: '最大のプライバシーのためのエンドツーエンド暗号化と自動ファイル削除',
  about_us_privacy_security_title: 'プライバシーとセキュリティ',
  about_us_privacy_security_description: 'あなたのプライバシーは私たちの最優先事項です。データを保護する方法は以下の通りです：',
  about_us_privacy_point_1: '可能な限りクライアントサイドで画像を処理',
  about_us_privacy_point_2: 'アップロードされたファイルは処理後に自動的に削除',
  about_us_privacy_point_3: '個人情報を追跡したりユーザーデータを保存したりしません',
  about_us_privacy_point_4: 'すべての通信は業界標準プロトコルで暗号化',
  about_us_community_title: 'コミュニティへの影響',
  about_us_community_description: 'ローンチ以来、Signal Sticker Makerは数千人のユーザーがカスタムステッカーパックを作成するのを支援してきました。私たちのコミュニティからの素晴らしい創造性を見てきました - 個人的な家族ステッカーからビジネスプロモーション材料、教育リソース、芸術的表現まで。作成されたすべてのステッカーパックは、デジタルコミュニケーションにおける誰かのユニークな声を表しています。',
  about_us_ads_description: '無料サービスの運営には持続可能な資金が必要です。私たちは倫理的な広告慣行を使用し、関連性があり高品質な広告主とのみ提携しています。広告収入はサーバーの維持、新機能の開発、すべての人にサービスを無料で提供し続けるために役立っています。私たちは広告収入のためにユーザーエクスペリエンスやプライバシーを犠牲にしないことを約束します。',
  about_us_future_title: '将来の計画',
  about_us_future_description: '私たちはSignal Sticker Makerの改善に絶えず取り組んでいます。以下が私たちの計画です：',
  about_us_future_point_1: 'ステッカーの微調整のための高度な編集ツール',
  about_us_future_point_2: '複数のパックを効率的に作成するためのバッチ処理',
  about_us_future_point_3: '簡単なステッカー作成のためのテンプレートライブラリ',
  about_us_future_point_4: '他のメッセージングプラットフォームとの統合',
  about_us_contact_title: 'お問い合わせ',
  about_us_contact_description: '私たちはユーザーの声を聞くのが大好きです！フィードバック、提案、または素晴らしいステッカー作品を共有したいだけでも、お気軽にお声がけください。あなたの意見は、私たちがすべての人のためにより良いツールを構築するのに役立ちます。',
  faq_intro: '包括的なFAQセクションへようこそ！ここではカスタムSignalステッカーの作成、ステッカーメーカーの使用、画像フォーマット、デザインのベストプラクティス、トラブルシューティングに関する最も一般的な質問への答えを見つけることができます。カスタムステッカー作成の初心者でも、メッセージングアプリステッカー作成スキルを完璧にしたい方でも、このガイドがお役に立ちます。',
  faq_question_4: 'サポートされている画像フォーマットは何ですか？',
  faq_answer_4: 'PNG、JPEG、WEBP、GIFフォーマットをサポートしています。透明度を持つ画像にはPNG、写真にはJPEG、ファイルサイズの最適化にはWEBP、シンプルなアニメーションにはGIFをお勧めします。各フォーマットは使用事例によってそれぞれの強みがあります。',
  faq_question_5: 'ステッカーの推奨画像サイズは何ですか？',
  faq_answer_5: '最適な結果を得るために、少なくとも512x512ピクセルの画像を使用してください。これにより、すべてのデバイスでステッカーが鮮明に表示されます。品質とファイルサイズのバランスを取るため、推奨最大サイズは1024x1024ピクセルです。',
  faq_question_6: '一つのパックに何個のステッカーを含めることができますか？',
  faq_answer_6: '3個から150個のステッカーを含むステッカーパックを作成できます。管理しやすく、適度なバラエティを保つために、10-30個のステッカーから始めることをお勧めします。人気のパックは通常、15-25個のステッカーで、さまざまな感情や状況をカバーしています。',
  faq_question_7: '私の画像はあなたのサーバーに保存されますか？',
  faq_answer_7: 'いいえ、私たちはあなたのプライバシーを優先します。画像は一時的に処理され、ステッカーパックが作成された後に自動的に削除されます。私たちはあなたの個人的な画像やデータをサーバーに保存しません。',
  faq_question_8: 'アニメーションステッカーを作成できますか？',
  faq_answer_8: 'はい！GIFファイルをアップロードしてアニメーションステッカーを作成できます。アニメーションステッカーはシンプルで、さまざまなデバイスでのパフォーマンスを確保するためにあまり長すぎないようにしてください。',
  faq_question_9: 'ステッカーパックを他の人と共有するにはどうすればよいですか？',
  faq_answer_9: 'パックを作成した後、Signalステッカーパックのリンクを受け取ります。このリンクを直接友達と共有したり、ソーシャルメディアに投稿したり、任意のメッセージングアプリで送信したりできます。リンクを持っている人は誰でも、あなたのステッカーをSignalアプリに追加できます。',
  faq_question_10: 'ステッカーがSignalで正しく表示されない場合はどうすればよいですか？',
  faq_answer_10: 'ステッカーがぼやけたり歪んだりして表示される場合は、より高解像度の画像（少なくとも512x512ピクセル）を使用し、サポートされているフォーマットであることを確認してください。最適な結果を得るためには、透明度を持つグラフィックにはPNGフォーマット、写真画像にはJPEGを使用してください。',
  faq_question_11: '著作権で保護された画像を使用できますか？',
  faq_answer_11: '所有しているか使用許可を得ている画像のみ使用すべきです。これには、あなたが撮影した写真、作成したグラフィック、または適切なライセンスを持つ画像が含まれます。許可なく著作権で保護された素材を使用することは著作権法に違反する可能性があります。',
  faq_question_12: '作成できるパック数に制限はありますか？',
  faq_answer_12: '作成できるステッカーパックの数に制限はありません。お好きなだけ作成してください！各パックは独立しており、それぞれ独自のテーマ、スタイル、目的を持つことができます。',
  faq_question_13: '作成後にステッカーパックを編集できますか？',
  faq_answer_13: 'ステッカーパックが作成されてSignalにアップロードされた後は、変更することはできません。しかし、変更を加えた新しいバージョンのパックを作成し、新しいリンクを共有することはできます。これはSignalがステッカーパックを処理する方法の制限です。',
  faq_question_14: 'ステッカーにJPEGではなくPNGを選ぶべき理由は何ですか？',
  faq_answer_14: 'PNGはステッカーに理想的です。透明度をサポートしており、ステッカーがどんなチャット背景ともシームレスに融合できます。PNGはまた可逆圧縮を提供し、グラフィックを鮮明に保ちます。JPEGは透明度が不要な写真系ステッカーのみに使用してください。',
  faq_question_15: '良いステッカーデザインとは何ですか？',
  faq_answer_15: '良いステッカーはシンプルで表情豊かで、小さくしても簡単に識別できるものです。鮮やかな色、明確な線を使用し、細かすぎることは避けてください。伝えたい感情や反応を考え、それに応じてデザインしてください。パック全体でスタイルの一貫性を保つことで、統一感のある外観を作り出せます。',
  faq_question_16: 'ビジネス用途でステッカーを作成できますか？',
  faq_answer_16: 'もちろんです！多くの企業がマーケティング、顧客エンゲージメント、ブランド構築のためにカスタムステッカーを使用しています。ロゴ、マスコット、ブランドキャラクターでステッカーを作成できます。ブランド要素を使用する権利を持っていることを確認してください。',
  faq_question_17: '画像を準備するために特別なソフトウェアが必要ですか？',
  faq_answer_17: '特別なソフトウェアは不要です！PhotoshopのようなプロフェッショナルソフトウェアからGIMPのような無料の代替品、さらにはシンプルなモバイルアプリまで、どんな画像編集ツールでも使用できます。重要なのは、画像がサイズとフォーマットの要件を満たしていることです。',
  faq_question_18: 'WEBPと他のフォーマットの違いは何ですか？',
  faq_answer_18: 'WEBPはGoogleが開発した現代的なフォーマットで、品質を維持しながら優れた圧縮を提供します。通常、透明度とアニメーションをサポートしながらPNGより25-35%小さいファイルを生成します。しかし、古いデバイスではWEBPサポートが限定的な場合があるため、PNGは安全な汎用的な選択肢であり続けています。',
  faq_still_questions_title: 'まだ質問がありますか？',
  faq_still_questions_description: 'お探しの答えが見つからなかった場合は、お気軽にサポートチームにお声がけください。素晴らしいステッカーパックの作成をお手伝いします！',
  faq_guides_description: 'ステッカー作成や画像フォーマット選択に関する詳細なガイドをチェックして、より深い情報を得ることもできます。',
};

const error = {
  error_file_size_title: '画像が最大ファイルサイズを超えています',
  error_file_size: '圧縮後の画像ファイルサイズが10MBを超えました。アップロード前に画像ファイルサイズをさらに制限してください。',
  error_conversion: '画像変換に失敗しました。他のブラウザやコンピューターでお試しください。'
};

const translation = {
  ...language_spec,
  ...content,
  ...text,
  // Sticker Guide Section - Japanese (for direct key access)
  sticker_guide_image_quality_title: text.sticker_guide_image_quality_title,
  sticker_guide_image_quality_1: text.sticker_guide_image_quality_1,
  sticker_guide_image_quality_2: text.sticker_guide_image_quality_2,
  sticker_guide_image_quality_3: text.sticker_guide_image_quality_3,
  sticker_guide_design_principles_title: text.sticker_guide_design_principles_title,
  sticker_guide_design_principles_1: text.sticker_guide_design_principles_1,
  sticker_guide_design_principles_2: text.sticker_guide_design_principles_2,
  sticker_guide_design_principles_3: text.sticker_guide_design_principles_3,
  sticker_guide_formats_title: text.sticker_guide_formats_title,
  sticker_guide_formats_description: text.sticker_guide_formats_description,
  sticker_guide_png_title: text.sticker_guide_png_title,
  sticker_guide_png_best_for: text.sticker_guide_png_best_for,
  sticker_guide_png_advantages: text.sticker_guide_png_advantages,
  sticker_guide_png_file_size: text.sticker_guide_png_file_size,
  sticker_guide_webp_title: text.sticker_guide_webp_title,
  sticker_guide_webp_best_for: text.sticker_guide_webp_best_for,
  sticker_guide_webp_advantages: text.sticker_guide_webp_advantages,
  sticker_guide_webp_file_size: text.sticker_guide_webp_file_size,
  sticker_guide_jpeg_title: text.sticker_guide_jpeg_title,
  sticker_guide_jpeg_best_for: text.sticker_guide_jpeg_best_for,
  sticker_guide_jpeg_advantages: text.sticker_guide_jpeg_advantages,
  sticker_guide_jpeg_limitations: text.sticker_guide_jpeg_limitations,
  sticker_guide_gif_title: text.sticker_guide_gif_title,
  sticker_guide_gif_best_for: text.sticker_guide_gif_best_for,
  sticker_guide_gif_advantages: text.sticker_guide_gif_advantages,
  sticker_guide_gif_limitations: text.sticker_guide_gif_limitations,
  sticker_guide_how_to_title: text.sticker_guide_how_to_title,
  sticker_guide_how_to_description: text.sticker_guide_how_to_description,
  sticker_guide_step_1: text.sticker_guide_step_1,
  sticker_guide_step_2: text.sticker_guide_step_2,
  sticker_guide_step_3: text.sticker_guide_step_3,
  sticker_guide_step_4: text.sticker_guide_step_4,
  sticker_guide_step_5: text.sticker_guide_step_5,
  sticker_guide_step_6: text.sticker_guide_step_6,
  sticker_guide_advanced_tips_title: text.sticker_guide_advanced_tips_title,
  sticker_guide_advanced_tips_description: text.sticker_guide_advanced_tips_description,
  sticker_guide_consistency_title: text.sticker_guide_consistency_title,
  sticker_guide_consistency_description: text.sticker_guide_consistency_description,
  sticker_guide_emotional_range_title: text.sticker_guide_emotional_range_title,
  sticker_guide_emotional_range_description: text.sticker_guide_emotional_range_description,
  sticker_guide_test_others_title: text.sticker_guide_test_others_title,
  sticker_guide_test_others_description: text.sticker_guide_test_others_description,
  ...menu_items,
  ...seo,
  ...error,
};

export default translation;